import { render, staticRenderFns } from "./AddAnotherSectionButton.vue?vue&type=template&id=5552e976&"
import script from "./AddAnotherSectionButton.vue?vue&type=script&lang=ts&"
export * from "./AddAnotherSectionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports